import { ENVS } from '@thom/folio-ui/envs'
import { TypedPocketBase } from '@thom/folio-ui/pocketbase-types'
import PocketBase from 'pocketbase'

const POCKETBASE_URL = ENVS.PUBLIC_API_URL

const createPocketBaseClient = (): TypedPocketBase => {
	const client = new PocketBase(POCKETBASE_URL) as TypedPocketBase

	// Auto-cancellation aborts an in-flight request whenever another shares its
	// key, and two components reading the same data at once is ordinary rather
	// than a mistake: the issues list and the tree context behind it make the
	// same query by design. Aborting one of them turns a correct read into a
	// failure. A superseded read is already handled a level up, where
	// useAsyncState drops any response whose generation has moved on, so
	// nothing here depends on the transport cancelling it.
	client.autoCancellation(false)

	return client
}

const browserClient = createPocketBaseClient()

const getPocketBaseClient = (): TypedPocketBase => browserClient

export { getPocketBaseClient }
